import React from 'react';
import SVG from 'react-inlinesvg';
import { ControlButton } from '../../../../components/control-button/control-button';
import rotateLeft from './assets/rotate-left.svg';
import rotateRight from './assets/rotate-right.svg';
import styles from './rotate-controls.module.scss';

export type RotateControlsProps = {
  onRotateLeft: () => void;
  onRotateRight: () => void;
  leftLabel?: string;
  rightLabel?: string;
};

export const RotateControls = ({
  onRotateLeft,
  onRotateRight,
  leftLabel = 'Rotate Left',
  rightLabel = 'Rotate Right',
}: RotateControlsProps) => {
  return (
    <div role="group" aria-label="Rotate controls" className={styles['rotate-controls']}>
      <ControlButton label={leftLabel} onClick={onRotateLeft}>
        <SVG src={rotateLeft} title={leftLabel} description={leftLabel} width={36} height={64} />
      </ControlButton>

      <ControlButton label={rightLabel} onClick={onRotateRight}>
        <SVG src={rotateRight} title={rightLabel} description={rightLabel} width={36} height={64} />
      </ControlButton>
    </div>
  );
};
